import { ICreateFiltroFolhaPagamentoUseCase } from "../../../presentation/useCases/create/create_filtro_folha_pagamento_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * CreateFiltroFolhaPagamentoUseCase
 */

export class CreateFiltroFolhaPagamentoUseCase implements ICreateFiltroFolhaPagamentoUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async createFiltroFolhaPagamento(
    colunas: string[],
  ): Promise<void> {
    await this.repository.createFiltroFolhaPagamento(colunas);
  }
}
